import { AuthConsumerRenderProps, withAuthContext } from 'auth/AuthContext';
import { PatientConsumerRenderProps, withPatientContext } from 'components/patient/PatientContext';
import { RouterProps } from 'react-router';
import styled from 'styled-components';
import PraxStyledSegment from 'components/layout/PraxStyledSegment';
import { MessageSourceProps, withMessages } from 'react-message-source';
import React, { useState } from 'react';
import { DocumentCopiesSearchResponse } from 'ts-types/api.types';
import FullScreenPageHeader from 'components/FullScreenPageHeader';
import CollectiveBillsSearchSegment
  from 'components/billing/home-collective-bills/segments/CollectiveBillsSearchSegment';
import { Divider } from 'semantic-ui-react';
import CollectedBillsTableView from 'components/billing/home-collective-bills/segments/CollectiveBillsTableSegment';

const StyledPraxSegment = styled(PraxStyledSegment)`
  margin-top: 0 !important;
  padding: 0 !important;
  margin-bottom: 5px !important;
`;

const ContentDiv = styled.div`
  flex: 1 1 auto;
  height: 100%;
  display: flex;
  flex-direction: column;
`;

interface Props extends AuthConsumerRenderProps, PatientConsumerRenderProps, MessageSourceProps, RouterProps {
}

const CollectiveBillsView = (props: Props) => {

  const {history, getMessage} = props;

  const [bills, setBills] = useState([] as DocumentCopiesSearchResponse[]);
  const [billsLoading, setBillsLoading] = useState(false);
  const [searchedId, setSearchedId] = useState(undefined as number | undefined);
  const [expandedBill, setExpandedBill] = useState(undefined as any);

  const goToHome = () => {
    history.push("/");
  };

  const onFilterBills = (bills: Array<DocumentCopiesSearchResponse>) => {
    setBills(bills);
  };

  const onBillsLoadingChange = (billsLoading: boolean) => {
    setBillsLoading(billsLoading);
  };

  const onSearchedId = (id: number) => {
    setSearchedId(id);
  }

  const onExpandedBill = (bill: any) => {
    setExpandedBill(bill);
  }

  return (
      <ContentDiv>
        <FullScreenPageHeader headerMessage={getMessage("header.navigation.collectiveBills")}
                              buttonMessage={getMessage("back")}
                              onConfirm={() => goToHome()}/>
        <StyledPraxSegment>
          <CollectiveBillsSearchSegment
            onFilterBills={onFilterBills}
            onBillsLoadingChange={onBillsLoadingChange}
            onSearchedId={onSearchedId}
            onExpandedBill={onExpandedBill}
          />
          <Divider/>
          <CollectedBillsTableView
              bills={bills}
              billsLoading={billsLoading}
              onFilterBills={onFilterBills}
              onBillsLoadingChange={onBillsLoadingChange}
              searchedId={searchedId}
              expandedBill={expandedBill}
              onExpandedBill={onExpandedBill}
          />
        </StyledPraxSegment>
      </ContentDiv>
  );
}

export default withAuthContext(withPatientContext(withMessages(CollectiveBillsView)));
